/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { EducationLevel, Gender, IdNowStatus, IdTypes, RoleNames, OccupationGroup } from '../types/utils';
import { Payment, PaymentID } from './payment-model';
import { InvestmentID } from './investment-model';
import { Company } from './company-model';
import { Experience } from './experience-model';
import { CreateWalletInput } from './create-wallet-input';

export type UserID = string;

export class User {
	id: UserID = ''

	address?: string

	addressZipcode?: string

	addressCity?: string

	addressCountry?: string

	availableCash?: number

	birthCity?: string

	birthDate?: Date

	cellphone?: string

	citizenship?: string

	company?: Company | null

	createdAt?: Date

	defaultPayment?: PaymentID

	email: string = ''

	employment?: string

	experience?: Array<Experience>

	firstName?: string

	gender?: Gender

	highestEducation?: EducationLevel

	idDocumentCountry?: string

	idDocumentNumber?: string

	idDocumentType?: IdTypes

	idNowId?: string

	idNowStatus?: IdNowStatus

	idNowTransactionId?: string

	investments?: Array<InvestmentID>

	lastName?: string

	monthlySalary?: number

	notUSTax?: boolean

	occupationGroup?: OccupationGroup

	passportIssuingAgency?: string

	payments?: Array<Payment>

	politicallyExposed?: boolean

	prevEmployment?: string

	role: RoleNames = RoleNames.USER

	taxNumber?: string

	updatedAt?: Date

	wallet?: CreateWalletInput
}